import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=2a798684&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"
import style0 from "./Games.vue?vue&type=style&index=0&id=2a798684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a798684",
  null
  
)

export default component.exports